import React, { useEffect } from 'react'
import { Dimmer, Form as SemanticForm, Icon, Loader, Modal } from 'semantic-ui-react'
import { Form } from 'react-final-form'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from '../../redux/store'
import { apiRequest } from '../../redux/actions/api'
import { API_LOGIN, API_LOGOUT, API_WHOAMI } from '../../consts'
import { OAUTH_LOGIN_REDIRECT, SET_CURRENT_USER } from '../../redux/actions/ui'

interface Props {
  children?: ((state: LoginState) => JSX.Element) | JSX.Element
}

export type LoginState =
  | {
      isAuthenticated: undefined
      username: undefined
      logout: () => void
    }
  | {
      isAuthenticated: true
      username: string
      logout: () => void
    }
  | {
      isAuthenticated: false
      username: null
      logout: () => void
    }

export const Login = (props: Props) => {
  const { children } = props
  const { currentUser } = useSelector((state: AppState) => state.ui)
  const dispatch = useDispatch()

  useEffect(() => {
    if (typeof currentUser === 'undefined') {
      dispatch(
        apiRequest({
          url: `${API_WHOAMI}`,
          entity: '',
          withCredentials: true,
          onSuccess: SET_CURRENT_USER,
          onError: SET_CURRENT_USER,
        })
      )
    }
  }, [currentUser, dispatch])

  const login = () => {
    dispatch(
      apiRequest({
        url: `${API_LOGIN}?json`,
        method: 'get',
        entity: '',
        withCredentials: true,
        onSuccess: OAUTH_LOGIN_REDIRECT,
        onError: OAUTH_LOGIN_REDIRECT,
      })
    )
  }

  const logout = () => {
    dispatch(
      apiRequest({
        url: `${API_LOGOUT}`,
        method: 'post',
        entity: '',
        withCredentials: true,
        onSuccess: SET_CURRENT_USER,
        onError: SET_CURRENT_USER,
      })
    )
  }

  const isAuthenticated = currentUser === undefined ? undefined : currentUser !== null
  return (
    <>
      {children
        ? typeof children === 'function'
          ? children({
              isAuthenticated,
              username: currentUser,
              logout,
            } as LoginState)
          : children
        : ''}
      <Dimmer active={currentUser === undefined} page>
        <Loader>Connecting...</Loader>
      </Dimmer>
      <Modal
        size="tiny"
        centered={true}
        closeOnDimmerClick={false}
        closeOnEscape={false}
        closeOnPortalMouseLeave={false}
        closeOnTriggerBlur={false}
        closeOnTriggerMouseLeave={false}
        closeOnDocumentClick={false}
        closeOnTriggerClick={false}
        closeIcon={false}
        open={currentUser === null}
      >
        <Modal.Header>Authentication required</Modal.Header>
        <Modal.Content>
          <Form
            onSubmit={login}
            render={({ handleSubmit, form }) => (
              <SemanticForm onSubmit={handleSubmit}>
                <SemanticForm.Group widths="equal">
                  <SemanticForm.Button primary floated="right" type="submit">
                    <Icon name="sign-in" />
                    Log in with Google SSO
                  </SemanticForm.Button>
                </SemanticForm.Group>
              </SemanticForm>
            )}
          />
        </Modal.Content>
      </Modal>
    </>
  )
}
